"use client";

import { Suspense, useEffect } from "react";

import { Authenticated } from "@refinedev/core";
import { NavigateToResource } from "@refinedev/nextjs-router";
import { useSearchParams } from "next/navigation";
import Cookies from "js-cookie";

export default function IndexPage() {
  const searchParams = useSearchParams();

  useEffect(() => {
    const atmp = searchParams.get("ATPM");
    const rt = searchParams.get("rt");

    const atmpExpires = new Date();
    atmpExpires.setHours(atmpExpires.getHours() + 12);

    // Set refresh token cookie to expire in 15 days
    const rtExpires = new Date();
    rtExpires.setDate(rtExpires.getDate() + 15);

    if (atmp && rt) {
      Cookies.set("ATPM", atmp, { path: "/", expires: atmpExpires });
      Cookies.set("rt", rt, { path: "/", expires: rtExpires });
    }
  }, [searchParams]);

  return (
    <Suspense>
      <Authenticated key="home-page">
        <NavigateToResource />
      </Authenticated>
    </Suspense>
  );
}
